import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../actions/app';
import { connect } from 'react-redux';

class Loading extends Component {

  render() {
    if(this.props.app.loading > 0){
      return (
        <div className="loading-component">
        </div>
      );
    }else{
      return false;
    }
    
  }
}

function mapStateToProps(state) {
  return {
    app: state.app
  }
}

function mapDispachToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispachToProps)(Loading);